import { render, staticRenderFns } from "./dashboard-notice.vue?vue&type=template&id=24975c85&scoped=true&"
import script from "./dashboard-notice.vue?vue&type=script&lang=js&"
export * from "./dashboard-notice.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-notice.vue?vue&type=style&index=0&id=24975c85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24975c85",
  null
  
)

export default component.exports